import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import './index.css';

import '../node_modules/normalize.css/normalize.css'
import '../node_modules/@blueprintjs/core/dist/blueprint.css'
import '../node_modules/leaflet/dist/leaflet.css'

import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { composeWithDevTools } from 'redux-devtools-extension'

import masterReducer from './reducers/masterReducer'

require('eventsource-polyfill')

const store = createStore(masterReducer, composeWithDevTools())

//ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.render(
    <Provider store={ store }>
        <App />
    </Provider>,
    document.getElementById('root')
)
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js